module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paymentFailed":"We were unable to charge the card. Try another payment method.","paymentFailedTitle":"Payment has failed"}}')
  delete Component.options._Ctor
}
